"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PlanningUI_1 = __importDefault(require("./PlanningUI"));
const connect_1 = __importDefault(require("./connect"));
require("./index.scss");
// Auto-planner panel. This used to be a right-side Sidebar of its own; it now renders in the
// top half of the manager assistant column, above the chat. Nothing here decides WHETHER to
// render — the column does, off managerAssistant.planningOpen.
const PlanningPanel = ({ createPlan, deleteCurrentPlan, closePlanning, setModal, ws, calendarMultiSelect, setCalendarMultiSelect, positions, }) => (react_1.default.createElement("div", { className: 'ds-planning-sidebar-content' },
    react_1.default.createElement(PlanningUI_1.default, { ws: ws, positions: positions, calendarMultiSelect: calendarMultiSelect, closePlanning: closePlanning, setModal: setModal, setCalendarMultiSelect: setCalendarMultiSelect, createPlan: createPlan, deleteCurrentPlan: deleteCurrentPlan })));
exports.default = (0, connect_1.default)(PlanningPanel);
